/**
 * W124 design layer scripts.
 * <w124-carousel>: scroll-snap carousel with prev/next buttons found in the closest [data-w124-carousel-root].
 */
if (!customElements.get('w124-carousel')) {
  customElements.define(
    'w124-carousel',
    class W124Carousel extends HTMLElement {
      connectedCallback() {
        const root = this.closest('[data-w124-carousel-root]') || this;
        this.track = this.querySelector('[data-w124-track]');
        this.prev = root.querySelector('[data-w124-prev]');
        this.next = root.querySelector('[data-w124-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      go(direction) {
        const slide = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = (slide?.offsetWidth || 300) + gap;
        this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      update() {
        const { scrollLeft, clientWidth, scrollWidth } = this.track;
        this.prev.disabled = scrollLeft < 4;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 4;
      }
    }
  );
}
